import { Drawer } from "~/components/ui-components/v2"

import {
  SUNGAGE_HOSTED_APPLICATION_TITLE,
  SUNGAGE_HOSTED_URL_UNAVAILABLE,
} from "./sungage-application-copy"
import { Eyebrow } from "../../../BatteryOnlyProposal/primitives"

const httpsApplicationUrl = (url: string): string | null => {
  try {
    const parsed = new URL(url)
    return parsed.protocol === `https:` ? parsed.toString() : null
  } catch {
    return null
  }
}

/**
 * Hosted Sungage borrower application, for any Proposal Kind. Closing does
 * not start or cancel anything; resume uses the same server attempt. Only an
 * https URL is framed.
 */
export function SungageHostedApplication({
  url,
  onClose,
  eyebrow,
  testIdPrefix,
}: {
  url: string
  onClose: () => void
  /** The kind's program, above the title. */
  eyebrow: string
  /** `${prefix}-sungage-hosted-…` test ids. */
  testIdPrefix: string
}): JSX.Element {
  const hostedSrc = httpsApplicationUrl(url)

  return (
    <Drawer
      open
      theme="dark"
      onClose={onClose}
      title={SUNGAGE_HOSTED_APPLICATION_TITLE}
      widthClass="sm:max-w-[90vw]"
      hideCloseButton
      contentClassName="flex flex-col pb-0"
      data-testid={`${testIdPrefix}-sungage-hosted-application`}
      header={({ close }) => (
        <div className="border-b border-bp-border bg-bp-base px-6 pt-5 pb-5">
          <div className="flex items-start justify-between gap-4">
            <div>
              <Eyebrow className="mb-1">{eyebrow}</Eyebrow>
              <h2 className="font-display text-[length:var(--step-2)] font-semibold text-bp-text">
                {SUNGAGE_HOSTED_APPLICATION_TITLE}
              </h2>
              <p className="mt-1 text-[length:var(--step--1)] text-bp-text-muted">
                Complete the application in Sungage. Closing returns to the
                proposal without creating another attempt.
              </p>
            </div>
            <button
              type="button"
              onClick={close}
              data-testid={`${testIdPrefix}-sungage-hosted-application-close`}
              className="rounded-md px-2 py-1 text-[length:var(--step--2)] font-semibold text-bp-text-muted hover:text-bp-text"
            >
              Close
            </button>
          </div>
        </div>
      )}
    >
      {hostedSrc != null ? (
        <iframe
          title={SUNGAGE_HOSTED_APPLICATION_TITLE}
          data-testid={`${testIdPrefix}-sungage-hosted-iframe`}
          allowFullScreen
          className="min-h-[70vh] w-full rounded-md bg-white"
          referrerPolicy="no-referrer-when-downgrade"
          src={hostedSrc}
        />
      ) : (
        <p
          role="alert"
          data-testid={`${testIdPrefix}-sungage-hosted-url-unavailable`}
          className="px-6 py-4 text-[length:var(--step--1)] text-bp-danger"
        >
          {SUNGAGE_HOSTED_URL_UNAVAILABLE}
        </p>
      )}
    </Drawer>
  )
}
